import React from 'react';

import { Drawer, Divider, useTheme, useMediaQuery } from '@mui/material';

import SidebarHeader from './SidebarHeader';
import SidebarContent from './SidebarContent';

const drawerWidth = 240;

function Sidebar({ open, toggleDrawer, pinned, togglePin }) {
  const theme = useTheme();
  const is_mobile = useMediaQuery(theme.breakpoints.down('md'));
  // Ignore pinned state on mobile - always use open state
  const drawer_open = is_mobile ? open : pinned ? true : open;

  return (
    <>
      <Drawer
        variant='temporary'
        open={drawer_open}
        onClose={toggleDrawer}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
        }}
      >
        <SidebarHeader
          toggleDrawer={toggleDrawer}
          pinned={pinned}
          togglePin={togglePin}
        />
        <Divider sx={{ color: theme.palette.brandBlack.contrastText }} />
        <SidebarContent toggleDrawer={toggleDrawer} />
      </Drawer>
      <Drawer
        variant={pinned ? 'permanent' : 'persistent'}
        sx={{
          display: { xs: 'none', md: 'block' },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            borderRight: `1px solid ${theme.palette.brandBlack.main}`,
          },
        }}
        open={drawer_open}
      >
        <SidebarHeader
          toggleDrawer={toggleDrawer}
          pinned={pinned}
          togglePin={togglePin}
        />
        <Divider />
        <SidebarContent toggleDrawer={toggleDrawer} />
      </Drawer>
    </>
  );
}

export default Sidebar;
